import Route from '@ember/routing/route';
import { service } from '@ember/service';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import { REVPAK_PATHS } from 'lumen/utils/spider';

@protectedRoute({ features: ['spider.revpak'] })
export default class HotelRevpakIndexRoute extends Route {
  @service router;

  redirect() {
    this.router.replaceWith('hotel.revpak.spider-dashboard', REVPAK_PATHS[0]);
  }
}
